import { render, staticRenderFns } from "./DialogRemoveIdea.vue?vue&type=template&id=771bee85"
import script from "./DialogRemoveIdea.vue?vue&type=script&lang=js"
export * from "./DialogRemoveIdea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports